import EndPointConfig from '../../models/api/EndPointConfig'

const controller = 'Bookings'

export const BookingsEP: EndPointConfig[] = [

  new EndPointConfig()
    .setMethod("GET")
    .setController(controller)
    .setActionName("GetBookings"),

  new EndPointConfig()
    .setMethod("GET")
    .setController(controller)
    .setActionName("ExportBookings"),

  new EndPointConfig()
    .setMethod("GET")
    .setController(controller)
    .setActionName("GetBookingsByAccountId"),


  new EndPointConfig()
    .setMethod("GET")
    .setController(controller)
    .setActionName("GetBookingData"),

  new EndPointConfig()
    .setMethod("POST")
    .setController(controller)
    .setActionName("ImportBookingRewards"),

  new EndPointConfig()
    .setMethod("POST")
    .setController(controller)
    .setActionName("CancelBookingRewards"),

  new EndPointConfig()
    .setMethod("POST")
    .setController(controller)
    .setActionName("CompleteBookingPayment"),

  new EndPointConfig()
    .setMethod("DELETE")
    .setController(controller)
    .setActionName("DeletePendingBookings"),

]